<template>
    <div class="bg_eef1fa">
        <div class="banner">
            <div class="banner_bg"><img src="@/assets/images/video_swiper_bg.jpg" /></div>
            <div class="main">
                <div class="swiper-container banner_container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in hot_list">
                            <a :href="item.url" v-if="item.url.length > 0" target="_blank">
                                <img :src="item.pic"  />
                            </a>
                            <img :src="item.pic" v-else />
                        </div>
                    </div>
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
        <div class=" video web_video">
            <div class="main bg_fff">
                <div class="text_pic_top_title no_before pa_top_15 padding_left_half flex_space_between align_items_center">
                    <p>音频</p>
                </div>
                <div class="audit_box flex_start flex_wrap">
                    <div class="audit_list" v-for="(item,index) in datalist" @click="goUrl(this,item.id,item.type)">
                        <div class="audit_list_img">
                            <img :src="item.pic" />
                        </div>
                        <h2>{{item.title}}</h2>
                        <p class="flex_start flex_wrap">
                            <span v-for="(val,key) in item.flag">{{val}}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="page" v-html="page_html">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Audit',
        data(){
            return {
                page:1,
                datalist: [],
                hot_list: [],
                page_html :''
            }
        },
        created(){
            if(this.$route.query.page) {
                this.page = this.$route.query.page;
            }
            this.listChange('audit',this.page);
        },
        watch:{
        },
        mounted() {
        },
        methods:{
            listChange: function (type,page) {
                let _this = this;
                _this.page = page;
                this.$http({
                    url: 'index/listInfo',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{page:page,type:type}
                }).then(res => {
                    if(res.data.code == 1) {
                        _this.datalist = res.data.data.list;
                        _this.hot_list = res.data.data.hot;
                        _this.page_html = res.data.data.page;

                        this.$nextTick(() => {
                            new Swiper(".banner_container", {
                                loop: true,
                                pagination:".banner_pagination",
                                autoplay: 3000,
                                slidesPerView: 3, // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
                                centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
                                spaceBetween:0, //  每张图片之间的间隔
                                nextButton: '.swiper-button-next',
                                prevButton: '.swiper-button-prev'
                            });
                        });
                    } else {
                        layer.msg(res.data.msg);
                    }
                });
            },
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            }
        },
    }
</script>
<style scoped>
    .video{padding:45px 0 25px;}
    .swiper-container {width:100%;display: block;overflow: hidden;position: relative;}
    .swiper-slide img{width:100%;height:100%;max-height:402px;object-fit: cover;display: block;}
    .banner_pagination .swiper-pagination-bullet{width:15px !important;height: 15px !important;background: #fff;opacity: 1;box-shadow: 0 0 5px rgba(0,0,0,.3);}
    .banner_pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{background: #66b5d3;}
    .swiper-slide-next,.swiper-slide-prev{width: 227px !important;height: 290px;top:56px;}
    .swiper-slide-active{width: 746px !important;height: 402px;}

    .swiper-button-next, .swiper-button-prev{width: 60px;height: 60px;border-radius: 50%;background-color: rgba(102,102,102,.6);text-align: center;background-repeat: no-repeat;background-position: center;background-size: 32px;opacity: 1 !important;}
    .swiper-button-prev{background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAAKBJREFUSEtjZKAhYKSh2QyjhmMNXYLBoqCiVs/IwOhw/85NR1LjB6/hUIMb/jP8b3hw51Yj1Qyn1GCQQ7C6nBoGYzWcWgZjGI5sMAMD00FSw/gfw59Xj+7cuQbThxIsiirq/0k1EFn9f4b/V/8x/AuDWYBiOE1dDnIFzcIc5kVqWYAzE1HDgoHJoWhBRP2yhZJkiTP7U2oo1kxELUOHvuEA5K1gGCqInWcAAAAASUVORK5CYII=");left:-70px;}
    .swiper-button-next{background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAAKhJREFUSEvt1DEKwjAUBuCvN1PvIOimm5u4uLm5CQ4u4qSb4iX0ZkqgQqmt1NQ4NZAl0O9PX/KSSTiyhLYOr6xubFluOODy6cxi8TNGmOJUFxCLB++ICWb5X7xltMEDts/xOXZlvS0evC0WWGJTDCjjvcimGmCVz/XLKOJDXCPx4md93MPC33Yeu+nGNf82INltSXbPk3boA+NUb0ujs/lFh9YGdXhlaZ4bHBoYWT3XEwAAAABJRU5ErkJggg==");right:-70px;}

    .banner{width:100%;position: relative;padding:40px 0;}
    .banner_bg{width:100%;position: absolute;top:0;right:0;bottom:0;left:0;z-index:1;}
    .banner_bg img{width: 100%;height: 100%;object-fit: cover;display: block;}
    .banner .main{position: relative;z-index:2;}


    .text_pic_top_title{width:100%;padding-left:40px;position: relative;background:#fff;height: 70px;line-height: 70px;margin-bottom: 20px;position: relative;z-index: 2;}
    .text_pic_top_title::before{content:"";position: absolute;top:0;left:0;width: 8px;height: 70px;background:#627eb6;}
    .no_before::before{display: none;}
    .text_pic_top_title p{width: auto;font-size:40px;color:#333;display: block;}
    .text_pic_top_title a{width: auto;font-size:20px;color:#333;display: block;padding-right: 20px;}
    .audit_box{width:100%;}
    .audit_list{width: 245px;margin:20px 40px 70px 20px;}
    .audit_list:nth-child(4n){margin-right: 20px;}
    .audit_list a{width: 100%;display: block;}
    .audit_list_img{width:100%;height: 245px;padding:8px;border-radius: 10px;box-shadow: 0 0 20px rgba(235,235,235,.8);overflow: hidden;display: block;transition: all ease .5s;}
    .audit_list_img img{width: 100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .audit_list:hover .audit_list_img{transform: scale(1.15) translateY(-18px);}
    .audit_list h2{width: 100%;font-size:20px;color:#333;font-weight: normal;display: block;line-height: 30px;margin:18px 0 45px;padding-left:8px;}
    .audit_list p{width: 100%;}
    .audit_list p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px;}
    .page{max-width: 1200px;margin:15px auto;}

    .padding_left_half{padding-left:19.5px;}

    @media screen and (max-width: 1920px) {
        .web_video{width: 96%;margin:0 auto;padding:3.629vw 0 2.016vw;}
        .audit_list{width:50%;margin:3.2vw 0 3.2vw !important;padding:0 3.2vw;}
        .audit_list_img{height: 41.53vw;max-height: 490px}
        .audit_list h2{margin:1.45vw 0 3.629vw;}
        .audit_list p span{border-radius: 5px;margin-right: 1.29vw;}
        .swiper-slide-next,.swiper-slide-prev{width: 20.306vw !important;height:23.387vw;top:4.516vw;}
        .swiper-slide-active{width: 62vw !important;height:32.419vw;}
    }
    @media screen and (max-width: 640px) {
        .text_pic_top_title p {
            font-size: 5.25vw;
        }

        .text_pic_top_title {
            margin-bottom: 3.2vw;
            height: 10.9375vw;
            line-height: 10.9375vw;
            padding-left: 2vw;
        }

        .text_pic_top_title::before {
            height: 10.9375vw;
        }
        .audit_list p span{font-size:10px;line-height: 18px;padding:0 5px;}
    }
    @media screen and (max-width: 440px) {
        /*.audit_list{width:100%;}
        .audit_list_img{height: 90vw;}*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/audit/index.vue